import React from 'react'
import { useEffect, useState } from 'react';
import axios from 'axios';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from 'react-router-dom';
import TaskSkeleton from "./TaskSkeleton";

export default function AddAgents() {
    const navigate = useNavigate();
    const [tasks, setTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { http, user } = AuthUser();
    const [formData, setFormData] = useState({
        name: '',
        ext_1: '',
        user_company_id: user.company_id
    });

    const initialState = {
        name: '',
        ext_1: '',
        user_company_id: user.company_id
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    useEffect(() => {
        setIsLoading(true);
        let endpoint = `/agent?company_id=${user.company_id}`;
        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }

        try {
            const res = await http.post('/agent_add', form);

            // On successful response
            if (res.status === 201) {
                toast.success("Agent added successfully!");
                setFormData(initialState);
                navigate('/agent_list');
            }
        } catch (error) {
            // On error response
            if (error.response) {
                console.error('Error adding agent:', error.response.data);

                // Show the error message to the user
                toast.error(error.response.data.message || 'Failed to add agent');
            } else {
                console.error('Unexpected error:', error);
                toast.error('Unexpected error occurred');
            }
        }
    };


    return (
        <>

            <div className="container mt-5">
                <Toaster />
                <h3>Add Agents</h3>
                <form onSubmit={handleSubmit}>
                    <div className='form-group mt-3'>
                        <label>Agent Name</label>
                        <input
                            name="name"
                            className='form-control'
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className='form-group mt-3'>
                        <label>Agent Phone</label>
                        <input
                            type='number'
                            name="ext_1"
                            className='form-control'
                            value={formData.ext_1}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <button className='btn button btn-success mt-3' type="submit">Add</button>
                </form>

                <div className="table-responsive mt-3">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : (
                        <table className="table table-striped">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-danger">No</th>
                                    <th>Name</th>
                                    <th>Phone</th>

                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((taskuser, index) => (
                                    <tr key={taskuser.id}>
                                        <td>{index + 1}</td>
                                        <td>{taskuser.name}</td>
                                        <td>{taskuser.ext_1}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </>
    )
}
